import React from 'react';
import { IngestWithContext } from '@wealthlane/chatbot';
import { axiosInstance } from '../../services/apiInterceptor';
import { toast } from 'react-toastify';
import ToastComponent from '../toast';
import { useNavigate } from 'react-router-dom';
import useInstance from '../../hooks/custom-hooks/useInstance';
import { getTenantId } from '@apps/customer/utils/tenantHelpers';
import { configState, devLogger } from '../chatbot/config';

function IngestComponent() {
  const navigate = useNavigate();
  const { getCurrentCid } = useInstance();
  const cid = getCurrentCid();
  const restUrl = process.env.REACT_APP_CHATBOT_REST_URL ?? '';

  return (
    <IngestWithContext
      axiosInstance={axiosInstance}
      config={configState}
      navigate={navigate}
      goBackAccessor={() => navigate(-1)}
      companyId={cid?.toString?.() ?? ''}
      tenantIdAccessor={getTenantId}
      logger={devLogger}
      alertFunctionSuccess={(message: string) => {
        toast.success(<ToastComponent label='Success' message={message} />);
      }}
      alertFunctionError={(message: string) => {
        toast.error(<ToastComponent label='Error' message={message} />);
      }}
      metadataDocumentLink={`${restUrl}/ingest/document/metadata/list?status=uploaded`}
      createDocumentLink={`${restUrl}/generate-presigned-url`}
      previewDocumentLink={`${restUrl}/get-preview-presigned-url`}
      saveDocumentLink={`${restUrl}/ingest/publish`}
      documentListLink={`${restUrl}/ingest/document/list`}
      setAsActiveDocumentLink={`${restUrl}/ingest/document/version/rollback`}
      transcribeAudioLink={process.env.REACT_APP_CHATBOT_AUDIO_TRANSCRIBE_URL || ''}
      chunkPreviewLink={`${restUrl}/ingest/document/chunks`}
      sourceDetailLink={`${restUrl}/ingest/sources`}
      chunkValidateLink={`${restUrl}/ingest/chunk/validate`}
      chunkEditLink={`${restUrl}/ingest/chunk/edit`}
      chunkPromoteLink={`${restUrl}/ingest/chunk/promote`}
      chunkRevertLink={`${restUrl}/ingest/chunk/revert`}
      chunkPendingLink={`${restUrl}/ingest/chunk/pending`}
      chunkDiscardDraftsLink={`${restUrl}/ingest/chunks/discard-drafts`}
      chunkArchiveLink={`${restUrl}/ingest/chunks/archive`}
      chunkTestQueryLink={`${restUrl}/ingest/chunk/test-query`}
      suggestLink={`${restUrl}/ingest/suggest`}
      publishLink={`${restUrl}/ingest/publish`}
      taxonomyFacetsLink={`${restUrl}/taxonomy/facets`}
      taxonomyOptionsLink={`${restUrl}/taxonomy/options`}
      versionInfoLink={`${restUrl}/ingest/document/version/list?logical_id=`}
      promoteDocumentLink={`${restUrl}/ingest/document/update-status`}
      ingestJobsLink={`${restUrl}/ingest/jobs`}
      allowPromote={true}
      allowTest={true}
      cid={cid?.toString?.() ?? ''}
    />
  );
}

export const Ingest = IngestComponent;
